import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import './FormCheckbox.css';

const FormCheckbox = ({
	name,
	control,
	label,
	required = false,
	disabled = false,
	validate,
	rules = {},
	className = '',
	helpText,
	variant = 'default', // 'default', 'switch'
	inline = false,
	onChange,
	...props
}) => {
	// Build validation rules
	const validationRules = {
		required: required
			? typeof required === 'string'
				? required
				: `${label} is required`
			: false,
		...(validate && { validate }),
		...rules,
	};

	return (
		<Controller
			name={name}
			control={control}
			rules={validationRules}
			render={({ field, fieldState: { error } }) => (
				<div className={`mb-3 ${className}`}>
					<div
						className={`form-checkbox-wrapper form-checkk ${
							variant === 'switch' ? 'form-switch' : ''
						} ${inline ? 'form-check-inline' : ''}`}
					>
						<input
							{...field}
							{...props}
							id={name}
							type="checkbox"
							className={`form-check-input ${error ? 'is-invalid' : ''}`}
							disabled={disabled}
							checked={field.value || false}
							onChange={(e) => {
								field.onChange(e.target.checked);
								if (onChange) {
									onChange(e.target.checked);
								}
							}}
						/>
						{label && (
							<label htmlFor={name} className="form-check-label">
								{label} {required && <span className="text-danger">*</span>}
							</label>
						)}
					</div>

					{error && (
						<div className="invalid-feedback d-block">{error.message}</div>
					)}

					{helpText && !error && <div className="form-text">{helpText}</div>}
				</div>
			)}
		/>
	);
};

FormCheckbox.propTypes = {
	name: PropTypes.string.isRequired,
	control: PropTypes.object,
	label: PropTypes.string,
	required: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	disabled: PropTypes.bool,
	validate: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
	rules: PropTypes.object,
	className: PropTypes.string,
	helpText: PropTypes.string,
	variant: PropTypes.oneOf(['default', 'switch']),
	inline: PropTypes.bool,
	onChange: PropTypes.func,
};

export default FormCheckbox;
